import React from 'react';
import './Modals.css';

const SettingsModal = ({ onClose }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content settings-modal">
                <div className="modal-header">
                    <h3>⚙️ Ustawienia profilu</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body">
                    <div className="input-group">
                        <label>Stare hasło</label>
                        <div className="password-wrapper">
                            <input type="password" placeholder="************" />
                            <span className="eye-icon">👁️</span>
                        </div>
                    </div>
                    <div className="input-group">
                        <label>Nowe hasło</label>
                        <div className="password-wrapper">
                            <input type="password" placeholder="************" />
                            <span className="eye-icon">👁️</span>
                        </div>
                    </div>
                    <div className="input-group">
                        <label>Powtórz nowe hasło</label>
                        <div className="password-wrapper">
                            <input type="password" placeholder="************" />
                            <span className="eye-icon">👁️</span>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button className="btn-cancel" onClick={onClose}>Anuluj</button>
                        <button className="btn-save">Zapisz zmiany</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsModal;